import React from 'react'

import { Icon, ChevronRight, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string } from 'prop-types'

import List from 'Pods/Shared/Icons/List'

const ChevronRightIcon = <Icon
  color="light"
  size="default"
  svgComponent={ChevronRight}
/>

const ListIcon = <List width="20" height="20" />

function ActionsBar({ baseUrl, translations }) {
  const actions = [
    { key: 'new', label: translations.new, href: `${baseUrl}/new` },
    { key: 'trending', label: translations.trending, href: `${baseUrl}/trending` },
    { key: 'topSelling', label: translations.topSelling, href: `${baseUrl}/top-selling` },
  ]

  return (
    <div className="actions-bar">
      <div className="actions-bar__list">
        {actions.map((action) => (
          <Button
            key={action.key}
            href={action.href}
            type="secondary-with-primary-border"
            customClass="actions-bar__link"
            noWrap
          >
            {action.label}
          </Button>
        ))}
        <Button
          href={`${baseUrl}?page=1`}
          type="primary"
          customClass="actions-bar__link actions-bar__link--primary"
          icon={ListIcon}
          trailIcon={ChevronRightIcon}
          variant="with-icon"
          noWrap
        >
          {translations.allModels}
        </Button>
      </div>
    </div>
  )
}

ActionsBar.propTypes = {
  baseUrl: string.isRequired,
  translations: shape({
    new: string.isRequired,
    trending: string.isRequired,
    topSelling: string.isRequired,
    allModels: string.isRequired,
  }).isRequired,
}

export default ActionsBar
